import { useTranslation } from "react-i18next";

import { PROGRAMME_CONTACT_HREF } from "@/domains/certifications/constants";
import { HelpCardProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const HelpCard = ({ question, linkLabel }: HelpCardProps) => {
  const { t } = useTranslation();

  return (
    <section className="module-help-card flex flex-col gap-200">
      <h2 className="certification-heading body-m-medium">
        {t("certification.labels.needHelp")}
      </h2>

      {question && (
        <p className="certification-muted body-s-regular">{question}</p>
      )}

      {linkLabel && (
        <a
          href={PROGRAMME_CONTACT_HREF}
          className="certification-link body-s-medium"
        >
          {linkLabel}
        </a>
      )}
    </section>
  );
};

export default HelpCard;
